module.exports = __webpack_public_path__ + "0b482031098027e880ef394f94a2995a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2064_teaser_image.jpg
// module id = 583
// module chunks = 0